"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../../utils/helpers");
exports.NotesPage = {
    view() {
        return (0, mithril_1.default)("div", { style: "height: 100%; width: 100%; display: flex; flex-direction: column" }, (0, mithril_1.default)("div", { style: "padding-left: 1em" }, (0, mithril_1.default)("a", {
            href: "https://calendar.google.com/calendar/embed?src=clientsesame%40gmail.com&ctz=Europe%2FParis",
            target: "_blank"
        }, "Le calendrier ne s'affiche pas? Cliquez ici pour l'ouvrir à coté", (0, helpers_1.iconSpan)("fa-external-link-alt"))), (0, mithril_1.default)("iframe", {
            style: "width: 100%; height: 100%;",
            src: "https://calendar.google.com/calendar/embed?src=clientsesame%40gmail.com&ctz=Europe%2FParis",
            frameborder: "0", scrolling: "no"
        }));
    }
};
